import React from 'react'
import s from './OrderDetails.module.scss'

const Estimated = () => {
  return (
    <div className={s.estimated}>
        <div className={s.estimated__left}>Estimated Delivery Time</div>
        <div className={s.estimated__right}>14-28 Sep 2024</div>
    </div>
  )
}

export default Estimated